import React, { useState, useEffect } from 'react';
import { Window, TextInput, Button, Fieldset } from 'react95';
import { t } from '../data/translations';
import styles from '../styles/modules/LoginScreen.module.css';

interface LoginScreenProps {
  onLogin: (name: string, secretKey: string) => void;
  isLoading?: boolean;
  error?: string;
}

const LoginScreen: React.FC<LoginScreenProps> = ({ onLogin, isLoading = false, error }) => {
  const [name, setName] = useState('');
  const [secretKey, setSecretKey] = useState('');
  const [urlKey, setUrlKey] = useState<string | null>(null);

  // Читаем ключ из URL при загрузке
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const keyFromUrl = urlParams.get('key');
    if (keyFromUrl) {
      setUrlKey(keyFromUrl);
      setSecretKey(keyFromUrl);
    }
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const finalSecretKey = urlKey || secretKey;
    if (name.trim() && finalSecretKey.trim()) {
      onLogin(name.trim(), finalSecretKey.trim());
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginBox}>
        <Window className={styles.loginWindow}>
          <div className={styles.windowHeader}>
            <span>🎉 {t('auth.title')} - Вход</span>
          </div>
          <div className={styles.windowContent}>
            <div className={styles.loginContent}>
              <div className={styles.logo}>
                <span className={styles.birthdayIcon}>🎂</span>
                <h1 className={styles.title}>{t('auth.title')}</h1>
              </div>
              
              <form onSubmit={handleSubmit} className={styles.loginForm}>
                <Fieldset label="Данные для входа">
                  <div className={styles.inputGroup}>
                    <label htmlFor="name">{t('auth.nameLabel')}</label>
                    <TextInput
                      id="name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      onKeyPress={handleKeyPress}
                      placeholder={t('auth.namePlaceholder')}
                      disabled={isLoading}
                      className={styles.textInput}
                    />
                  </div>
                  
                  {/* {showSecretKeyInput && (
                    <div className={styles.inputGroup}>
                      <label htmlFor="secretKey">{t('auth.secretKeyLabel')}</label>
                      <TextInput
                        id="secretKey"
                        type="password"
                        value={secretKey}
                        onChange={(e) => setSecretKey(e.target.value)}
                        onKeyPress={handleKeyPress}
                        placeholder={t('auth.secretKeyPlaceholder')}
                        disabled={isLoading}
                        className={styles.textInput}
                      />
                    </div>
                  )}
                  
                  {urlKey && (
                    <div className={styles.keyFromUrl}>
                      ✅ Секретный ключ получен из ссылки
                    </div>
                  )} */}
                  
                  {error && (
                    <div className={styles.errorMessage}>
                      ❌ {error}
                    </div>
                  )}
                  
                  <div className={styles.buttonGroup}>
                    <Button
                      type="submit"
                      primary
                      disabled={!name.trim() || (!urlKey && !secretKey.trim()) || isLoading}
                      className={styles.loginButton}
                    >
                      {isLoading ? t('auth.checking') : t('auth.loginButton')}
                    </Button>
                  </div>
                </Fieldset>
              </form>
              
              <div className={styles.footer}>
                <p>{t('auth.footer')}</p>
              </div>
            </div>
          </div>
        </Window>
      </div>
    </div>
  );
};

export default LoginScreen; 